<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="职位名称"
                          prop="title">
              <el-input placeholder="请输入职位名称"
                        v-model="search.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="发布单位"
                          prop="employer_name">
              <el-input placeholder="请输入发布单位"
                        v-model="search.employer_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="状态"
                          prop="status">
              <el-select multiple
                         v-model="search.status"
                         placeholder="请选择状态">
                <el-option v-for="(value,index) in options.status"
                           :label="value.keyword"
                           :value="value.id"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="日期区间选择"
                          prop="datetimerange">
              <el-date-picker v-model="search.datetimerange"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              align="right"
                              value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <el-row>
      <el-button type="primary"
                 @click="onBatchDelete()">批量删除
      </el-button>
      <el-button type="primary"
                 @click="onBatchTopPosition()">批量刷新
      </el-button>
      <el-button type="primary"
                 @click="onBatchReleasePosition()">批量发布
      </el-button>
      <el-button type="primary"
                 @click="onBatchOfflinePosition()">批量下线
      </el-button>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @sort-change="onOrderByTable">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="title"
                         label="职位名称"></el-table-column>
        <el-table-column prop="position_strtype"
                         label="职位类型"></el-table-column>
        <el-table-column prop="employer_name"
                         label="发布单位"></el-table-column>
        <el-table-column prop="strstatus"
                         label="状态"></el-table-column>
        <el-table-column prop="unread_resume_count"
                         label="新投递简历数"></el-table-column>
        <el-table-column prop="total_resume_count"
                         label="递简总数"></el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         sortable="custom"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="onTopPosition(scope.row.id)">刷新职位
            </el-button>
            <el-button type="text"
                       size="mini"
                       @click="onReleasePosition(scope.row.id)"
                       v-if="scope.row.status === 0 || scope.row.status === 2">发布
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="onOfflinePosition(scope.row.id)"
                       v-if="scope.row.status === 1">
              下线
            </el-button>

            <span v-if="scope.row.status === 0 || scope.row.status === 2">
              <router-link :to="{ path: '/position/update/'+scope.row.id}">
                <el-button type="text"
                           size="mini">修改</el-button>
              </router-link>
              <el-button type="text"
                         size="mini"
                         @click="onDeletePosition(scope.row.id)">删除</el-button>
            </span>

            <router-link :to="{ path: '/position/detail/'+scope.row.id}">
              <el-button type="text"
                         size="mini">职位详情
              </el-button>
            </router-link>
            <router-link :to="{ path: '/resume/table' , query:{ id:scope.row.id ,title:scope.row.title}}">
              <el-button type="text"
                         size="mini">查看简历
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@/mixins/table-v1'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        platform: 1, // 主平台
        title: null,
        employer_name: null,
        datetimerange: [],
        status: [],
        sort_by_created_at: null,
      },
      // 搜索字段申明
      searchFieldType: {
        sort_by_created_at: Number,
        status: {0: Number, 1: Number, 2: Number},
        platform: Number,
      },
      multipleSelection: [],
      options: {
        status: [
          {id: 0, keyword: '待发布'},
          {id: 1, keyword: '已发布'},
          {id: 2, keyword: '已下线'},
        ],
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['getPositionTable', 'releasePosition', 'topPosition', 'batchTopPosition', 'deletePosition',
      'batchReleasePosition', 'batchOfflinePosition', 'offlinePosition',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getPositionTable', params)
    },
    onBatchDelete () {
      let multipleIds = {
        'job_ids': this.multipleSelection.map(item => item.id),
      }
      if (multipleIds.job_ids.length <= 0) {
        this.$message.error('请至少选择删除一个')
        return false
      }

      return request.common('batchDeletePosition', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '删除职位成功,成功' + res.data.length + '个,共' + multipleIds.job_ids.length + '个',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onTopPosition (id) {
      return request.common('topPosition', id).then((res) => {
        this.$message({
          showClose: true,
          message: '刷新职位成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onReleasePosition (id) {
      return request.common('releasePosition', id).then((res) => {
        this.$message({
          showClose: true,
          message: '发布职位成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onBatchReleasePosition () {
      let multipleIds = {
        'job_ids': this.multipleSelection.map(item => item.id),
      }
      if (multipleIds.job_ids.length <= 0) {
        this.$message.error('请至少选择发布一个')
        return false
      }

      return request.common('batchReleasePosition', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '批量发布职位成功,成功' + res.data.length + '个,共' + multipleIds.job_ids.length + '个',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onBatchTopPosition () {
      let multipleIds = {
        'job_ids': this.multipleSelection.map(item => item.id),
      }
      if (multipleIds.job_ids.length <= 0) {
        this.$message.error('请至少选择更新一个')
        return false
      }
      return request.common('batchTopPosition', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '批量刷新职位成功,成功' + res.data.length + '个,共' + multipleIds.job_ids.length + '个',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onDeletePosition (id) {
      return request.common('deletePosition', id).then((res) => {
        this.$message({
          showClose: true,
          message: '删除职位成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onOfflinePosition (id) {
      return request.common('offlinePosition', id).then((res) => {
        this.$message({
          showClose: true,
          message: '下线职位成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onBatchOfflinePosition () {
      let multipleIds = {
        'job_ids': this.multipleSelection.map(item => item.id),
      }
      if (multipleIds.job_ids.length <= 0) {
        this.$message.error('请至少选择下线一个')
        return false
      }
      return request.common('batchOfflinePosition', multipleIds).then((res) => {
        this.$message({
          showClose: true,
          message: '批量下线职位成功,成功' + res.data.length + '个,共' + multipleIds.job_ids.length + '个',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onOrderByTable (val) {
      if (val.order === 'descending') {
        this.search.sort_by_created_at = 2
      } else {
        this.search.sort_by_created_at = 1
      }
      this.onSearch()
    },
    handleSelectionChange (val, index) {
      this.multipleSelection = val
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionTable.vue